import { Effect, Layer, Schema } from "effect";
import { ResourceWorkspaceId } from "@workerstation/shared/resources/http";
import { ContainerInput } from "@workerstation/shared/resources/container";
import { resourceInvalid, resourceUnavailable } from "@workerstation/shared/errors/resource";
import { makeResourceControlClient, ownResourceRequest } from "../resources/live.ts";
import { PreparedContainerTarget } from "./model.ts";
import { ContainerApi } from "./service.ts";

export const makeContainerApi = Effect.fn("Frontend.ContainerApi.make")(function* (baseUrl: string) {
  const client = yield* makeResourceControlClient(baseUrl);
  return ContainerApi.of({
    load: Effect.fn("Frontend.ContainerApi.load")(function* (workspaceId) {
      const prepared = yield* Schema.decodeUnknownEffect(ResourceWorkspaceId)(workspaceId).pipe(Effect.mapError(() => resourceInvalid("Invalid Container workerspace id.")));
      const snapshot = yield* client.resources.containerBindings({ params: { workspaceId: prepared } });
      if (snapshot.workspaceId !== prepared || !snapshot.revision) return yield* Effect.fail(resourceUnavailable());
      return snapshot;
    }, ownResourceRequest),
    control: Effect.fn("Frontend.ContainerApi.control")(function* (target, command) {
      const prepared = yield* Schema.decodeUnknownEffect(PreparedContainerTarget)(target).pipe(Effect.mapError(() => resourceInvalid("Invalid Container target.")));
      const payload = yield* Schema.decodeUnknownEffect(ContainerInput)(command).pipe(Effect.mapError(() => resourceInvalid("Invalid Container action.")));
      const { revision, ...params } = prepared;
      const result = yield* client.resources.containerAction({ params, query: { revision }, payload });
      if (result.workspaceId !== params.workspaceId || result.bindingName !== params.bindingName || result.instance !== params.instance || result.action !== payload.action) return yield* Effect.fail(resourceUnavailable());
      return result;
    }, ownResourceRequest)
  });
});
export const ContainerApiLive = (baseUrl: string) => Layer.effect(ContainerApi, makeContainerApi(baseUrl));
